module.exports = __webpack_public_path__ + "static/media/screen_gallery_plus_7.6430b663.svg";